import { render, staticRenderFns } from "./DotsVerical.vue?vue&type=template&id=1c6b817e"
import script from "./DotsVerical.vue?vue&type=script&lang=js"
export * from "./DotsVerical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6b817e')) {
      api.createRecord('1c6b817e', component.options)
    } else {
      api.reload('1c6b817e', component.options)
    }
    module.hot.accept("./DotsVerical.vue?vue&type=template&id=1c6b817e", function () {
      api.rerender('1c6b817e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/DotsVerical.vue"
export default component.exports